import Vue from "vue";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import VueMeta from 'vue-meta';

Vue.use(VueMeta);
import { BootstrapVue } from "bootstrap-vue";
import { Datetime } from "vue-datetime";
import "vue-datetime/dist/vue-datetime.css";
import Toast, { TYPE } from "vue-toastification";
import "vue-toastification/dist/index.css";
import Vuelidate from "vuelidate";
import "vue2-datepicker/index.css";
import Datepicker from "vue2-datepicker";
import PosthogPlugin from '../plugins/posthog'

import toastMixin from "./components/mixin/toast";
Vue.use(Datepicker);
Vue.use(BootstrapVue);
Vue.use(Vuelidate);
Vue.use(PosthogPlugin)

// import "@/assets/globalcss/style.css";
import "@/assets/globalcss/newstyle.css";
import "@/assets/globalcss/typography.css";
import SearchBar from "./views/utils/SearchBar.vue";
import PrimaryButton from "./views/utils/PrimaryButton.vue";
import OutlineButton from "./views/utils/OutlineButton.vue";
import Loader from "./components/fixedComponents/Loader.vue";
import HorizontalScroll from "@/components/fixedComponents/HorizontalScroll.vue";
import VideoPlayer from "./views/utils/Video.vue";
import AudioPlayer from "./views/utils/Audio.vue";

const options = {
  // You can set your default options here
  toastDefaults: {
    [TYPE.ERROR]: {
      timeout: 5000,
      // icon: false,
      // closeButton: true,
      hideProgressBar: true,
    },
    [TYPE.SUCCESS]: {
      timeout: 5000,
      // icon: false,
      // closeButton: true,
      hideProgressBar: true,
    },
  },
};
Vue.config.productionTip = false;
Vue.use(Datetime);
Vue.component("datetime", Datetime);
Vue.use(Toast, options);
Vue.mixin(toastMixin);
Vue.component("SearchBar", SearchBar);
Vue.component("PButton", PrimaryButton);
Vue.component("OButton", OutlineButton);
Vue.component("Loader", Loader);
Vue.component("HorizontalScroll", HorizontalScroll);
Vue.component("VideoPlayer", VideoPlayer);
Vue.component("AudioPlayer", AudioPlayer);

Vue.filter("cloudlink", (url) => {
  try {
    const urlObject = new URL(url);
    const pathname = urlObject.pathname;
    const fileName = pathname.substring(pathname.lastIndexOf("/") + 1);
    const decodedFileName = decodeURIComponent(fileName);
    return decodedFileName;
  } catch (error) {
    return url;
  }
});

new Vue({
  el: "#app",
  router,
  store,
  render: (h) => h(App),
});
Vue.directive("closeArray", {
  bind(el, binding) {
    const { index, property, array, handler, exclude } = binding.value;

    const closeHandler = (event) => {
      // Build a selector string for exclusion elements
      const excludeSelector = exclude.map((item) => `.${item}`).join(", ");

      // Check if the click was outside the element and not on excluded elements
      if (
        !el.contains(event.target) &&
        !event.target.closest(excludeSelector)
      ) {
        // Check if the index is valid within the array
        if (index >= 0 && index < array.length) {
          // Toggle the property value for the specified index
          array[index][property] = !array[index][property];
        }

        // Call the handler function with index as a parameter
        handler(index);
      }
    };

    el.__closableClickOutsideHandler = closeHandler;
    document.addEventListener("click", closeHandler);
  },
  unbind(el) {
    document.removeEventListener("click", el.__closableClickOutsideHandler);
    delete el.__closableClickOutsideHandler;
  },
});
let handleOutsideClick;
Vue.directive("closable", {
  bind(el, binding, vnode) {
    // Here's the click/touchstart handler
    // (it is registered below)
    handleOutsideClick = (e) => {
      e.stopPropagation();
      // Get the handler method name and the exclude array
      // from the object used in v-closable
      const { handler, exclude } = binding.value;
      // This variable indicates if the clicked element is excluded
      let clickedOnExcludedEl = false;
      exclude.forEach((refName) => {
        // We only run this code if we haven't detected
        // any excluded element yet
        if (!clickedOnExcludedEl) {
          let excludedEl = vnode.context.$refs[refName];
          excludedEl = excludedEl instanceof Vue ? excludedEl.$el : excludedEl;
          // Get the element using the reference name
          // See if this excluded element
          // is the same element the user just clicked on
          if (excludedEl) {
            // See if this excluded element
            // is the same element the user just clicked on
            clickedOnExcludedEl = excludedEl.contains(e.target);
          }
        }
      });
      // We check to see if the clicked element is not
      // the dialog element and not excluded
      if (!el.contains(e.target) && !clickedOnExcludedEl) {
        // If the clicked element is outside the dialog
        // and not the button, then call the outside-click handler
        // from the same component this directive is used in
        vnode.context[handler]();
      }
    };
    // Register click/touchstart event listeners on the whole page
    document.addEventListener("click", handleOutsideClick);
  },
  unbind() {
    // If the element that has v-closable is removed, then
    // unbind click/touchstart listeners from the whole page
    document.removeEventListener("click", handleOutsideClick);
  },
});

Vue.directive("closeArray", {
  bind(el, binding) {
    const { index, property, array, handler, exclude } = binding.value;

    const closeHandler = (event) => {
      // Build a selector string for exclusion elements
      const excludeSelector = exclude.map((item) => `.${item}`).join(", ");

      // Check if the click was outside the element and not on excluded elements
      if (
        !el.contains(event.target) &&
        !event.target.closest(excludeSelector)
      ) {
        // Check if the index is valid within the array
        if (index >= 0 && index < array.length) {
          // Toggle the property value for the specified index
          array[index][property] = !array[index][property];
        }

        // Call the handler function with index as a parameter
        handler(index);
      }
    };

    el.__closableClickOutsideHandler = closeHandler;
    document.addEventListener("click", closeHandler);
  },
  unbind(el) {
    document.removeEventListener("click", el.__closableClickOutsideHandler);
    delete el.__closableClickOutsideHandler;
  },
});

Vue.prototype.$copyToClipboard = function (text) {
  if (window.ShareCopyBridge && window.ShareCopyBridge.copy) {
    window.ShareCopyBridge.copy(text);
  } else if (navigator.clipboard) {
    navigator.clipboard.writeText(text);
  }
};
